import React, { useRef, useCallback } from 'react';

interface MagnetButtonProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  strength?: number;
  radius?: number;
  onClick?: () => void;
}

export const MagnetButton: React.FC<MagnetButtonProps> = ({
  children,
  className = '',
  style,
  strength = 0.35,
  radius = 120,
  onClick,
}) => {
  const ref = useRef<HTMLButtonElement>(null);

  const handleMove = useCallback((e: React.PointerEvent) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const dx = e.clientX - cx;
    const dy = e.clientY - cy;
    const dist = Math.sqrt(dx * dx + dy * dy);

    if (dist < radius) {
      const factor = 1 - dist / radius;
      el.style.transform = `translate(${dx * strength * factor}px, ${dy * strength * factor}px)`;
    }
  }, [strength, radius]);

  const handleLeave = useCallback(() => {
    const el = ref.current;
    if (el) el.style.transform = 'translate(0, 0)';
  }, []);

  return (
    <button
      ref={ref}
      className={`magnetic-btn ${className}`}
      style={style}
      onClick={onClick}
      onPointerMove={handleMove}
      onPointerLeave={handleLeave}
    >
      {children}
    </button>
  );
};

export default MagnetButton;
